import { AutocompleteMultiSelect } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import type { TargetingFormValue, TargetingIabCategory } from '../../model';
import { InclusionToggle } from './InclusionToggle';
import type { TargetingFormUpdate } from './TargetingForm.types';
import { TargetingSection } from './TargetingSection';

export function ContentTargetingSection({
  iabCategories,
  updateField,
  value,
}: {
  iabCategories: TargetingIabCategory[];
  updateField: TargetingFormUpdate;
  value: TargetingFormValue;
}) {
  return (
    <TargetingSection title={dashboardT('targeting.content')}>
      <div className="grid gap-3">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span className="text-foreground text-sm font-medium">
            {dashboardT('targeting.iabCategories')}
          </span>
          <InclusionToggle
            included={value.iabCategoriesIncluded}
            onIncludedChange={(included) => {
              updateField('iabCategoriesIncluded', included);
            }}
          />
        </div>
        <AutocompleteMultiSelect
          label={dashboardT('targeting.iabCategories')}
          placeholder={dashboardT('targeting.chooseIabCategories')}
          emptyMessage={dashboardT('targeting.noIabCategories')}
          options={iabCategories.map((category) => ({ id: category.id, label: category.name }))}
          value={value.iabCategoryIds}
          maxResults={iabCategories.length}
          onValueChange={(ids) => {
            updateField('iabCategoryIds', ids);
          }}
        />
      </div>
    </TargetingSection>
  );
}
